export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CLOSE_POP_UP"] = "CLOSE_POP_UP";
    ACTION["CHANGE_INPUT_NAME"] = "CHANGE_INPUT_NAME";
    ACTION["CHANGE_INPUT_PAN"] = "CHANGE_INPUT_PAN";
    ACTION["DISABLE_SUBMIT"] = "DISABLE_SUBMIT";
    ACTION["ENABLE_SUBMIT"] = "ENABLE_SUBMIT";
    ACTION["CHANGE_INPUT_PHONE"] = "CHANGE_INPUT_PHONE";
    ACTION["CHANGE_INPUT_EMAIL"] = "CHANGE_INPUT_EMAIL";
    ACTION["TRIGGER_CTA"] = "TRIGGER_CTA";
    ACTION["CHANGE_INPUT_DOB"] = "CHANGE_INPUT_DOB";
    ACTION["PAN_SUCCESS_ACTION"] = "SUCCESS_ACTION";
    ACTION["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    ACTION["SEND_OTP_ACTION"] = "SEND_OTP_ACTION";
    ACTION["VERIFY_OTP_ACTION"] = "VERIFY_OTP_ACTION";
    ACTION["CANCEL_OTP_ACTION"] = "CANCEL_OTP_ACTION";
})(ACTION || (ACTION = {}));
// export type TestActionPayload = {}
